import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexRow,
  FlexRowCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';

export interface Props {
  name: string;
  position: string;
  phone: string;
  email: string;
  picture?: string;
  secondPhone?: string;
}

function ContactPerson({
  name,
  position,
  phone,
  email,
  picture,
  secondPhone,
}: Props) {
  return (
    <Wrapper>
      <ImageWrapper>
        {picture ? (
          <Image src={picture} alt={`Foto ${name}`} />
        ) : (
          <PersonIcon icon={IconType.person} />
        )}
      </ImageWrapper>
      <RightWrapper>
        <Name>{name}</Name>
        {position ? <Position>{position.trim()}</Position> : null}
        {phone ? (
          <ValueWrapper>
            <ValueName>{__('Tel. číslo')}</ValueName>
            <Phone>{phone.trim()}</Phone>
          </ValueWrapper>
        ) : null}
        {secondPhone ? (
          <ValueWrapper>
            <ValueName>{__('Mob. číslo')}</ValueName>
            <Phone>{secondPhone.trim()}</Phone>
          </ValueWrapper>
        ) : null}
        {email ? (
          <ValueWrapper>
            <ValueName>{__('Email')}</ValueName>
            <Email>{email.trim()}</Email>
          </ValueWrapper>
        ) : null}
      </RightWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  padding: ${rem(24)};
  margin-bottom: ${rem(32)};
  margin-right: ${rem(32)};
  width: 100%;
  max-width: ${rem(508)};
  border-radius: ${rem(2)};
  border: ${({ theme }) => theme.borders.primary};
  transition: box-shadow 0.3s;
  position: relative;

  &:nth-child(2n) {
    margin-right: 0;
  }

  &:hover {
    box-shadow: ${({ theme }) => theme.boxShadow.default};
  }

  ${({ theme }) => theme.mediab.l925`
    padding: ${rem(44)} ${rem(24)} ${rem(24)};
    margin-bottom: ${rem(44)};
    margin-right: 0;
  `}
`;

const RightWrapper = styled(FlexCol)`
  max-width: 70%;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

const ImageWrapper = styled(FlexRowCenter)`
  border-radius: 50%;
  width: ${rem(80)};
  height: ${rem(80)};
  background-color: rgba(49, 39, 131, 0.16);
  margin-right: ${rem(32)};

  ${({ theme }) => theme.mediab.l925`
    position: absolute;
    top: -${rem(28)};
    width: ${rem(56)};
    height: ${rem(56)};
  `}
`;

const Text = styled(TextP)`
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(22)};
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  font-size: ${rem(14)};
`;

const Name = styled(TextP)`
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(20)};
  line-height: ${rem(28)};
  margin-bottom: ${rem(8)};
`;

const Position = styled(Text)`
  margin-bottom: ${rem(20)};
`;

const Phone = styled(Text)``;

const Email = styled(Text)``;

const ValueWrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(4)};

  &:last-child {
    margin: 0;
  }

  ${({ theme }) => theme.mediab.m580`
    flex-flow: row wrap;
  `}
`;

const ValueName = styled(Text)`
  width: ${rem(70)};
  margin-right: ${rem(24)};
  font-weight: 400;
`;

const PersonIcon = styled(SvgIcon)`
  ${({ theme }) => theme.mediab.l925`
    width: ${rem(16)};
    height: ${rem(16)};
  `}
`;

export { ContactPerson };
